export default "__VITE_ASSET__716f1a1d__"